/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  IMediaModel,
  mediaDetailsTagHelper,
  MediaType,
  TimeHelper,
} from "@nf/common";
import React from "react";
import { useTranslation } from "next-i18next";
import cx from "classnames";
import styles from "./MediaAdditionalInfo.module.scss";

export interface MediaAdditionalInfoProps {
  media: IMediaModel;
  className?: string;
  separator?: string; // change separator from "," to "|"
  showDuration?: boolean;
}

export const MediaAdditionalInfo = ({
  media,
  className,
  separator = ", ",
  showDuration = true,
}: MediaAdditionalInfoProps) => {
  const { t } = useTranslation("translations");
  const mediaAdditionalInformations: string[] = [];

  if (media.MediaTypeCode === MediaType.Collection) {
    return (
      <div className={cx(styles.additionalInfo, className)}>
        {t("web_collection")}
      </div>
    );
  }

  if (media.Categories && media.Categories.length > 0) {
    const mainCategories = mediaDetailsTagHelper(media.Categories);

    if (mainCategories?.[0]) {
      mediaAdditionalInformations.push(mainCategories[0].CategoryName);
    }
  }

  if (media.Year) {
    mediaAdditionalInformations.push(`${media.Year}`);
  }

  if (media.Duration && showDuration) {
    mediaAdditionalInformations.push(
      `${TimeHelper.formatDuration(media.Duration)}`
    );
  }

  const mediaAdditionalInfo = mediaAdditionalInformations.join(separator);

  if (!mediaAdditionalInfo) {
    return null;
  }

  return (
    <div className={cx(styles.additionalInfo, className)}>
      {mediaAdditionalInfo}
    </div>
  );
};

export default MediaAdditionalInfo;
